import { createFileRoute, notFound } from '@tanstack/react-router';
import { requirePermission } from '@/features/admin/guard';
import { SystemOverviewPage } from '@/features/admin/system/system-overview';
import { featuresQuery } from '@/features/feature-flags/use-feature';

/** ADM-06; behind the feature flag `system_overview`. */
export const Route = createFileRoute('/_app/admin/system')({
  beforeLoad: async ({ context }) => {
    requirePermission(context.me, 'admin.system');
    const { flags } = await context.queryClient.query(featuresQuery);
    if (!flags.system_overview) throw notFound();
  },
  component: SystemOverviewPage,
});
